import { render, staticRenderFns } from "./positionChip.vue?vue&type=template&id=0ab2966e"
import script from "./positionChip.vue?vue&type=script&lang=js"
export * from "./positionChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports